import { API_URLs } from "../../../utilities/API_URLs";
import iAxios from "../../../utilities/axios/axios-setup";
import { Http } from "../../../utilities/axios/http";
import {
  MaterialType,
  MaterialState,
  MaterialEnergy,
  MaterialListResponse,
  MaterialItemData,
  MaterialPageState,
} from "./_model";

export const getMaterialTypes = async (): Promise<MaterialType[]> => {
  try {
    const r = await iAxios.get(API_URLs.settings.materials.getMaterialTypes);
    console.log("getMaterialTypes response:", r.data);
    return Array.isArray(r.data.member) ? r.data.member : [];
  } catch (e) {
    console.error("Error fetching material types:", e);
    return [];
  }
};

export const getMaterialStates = async (): Promise<MaterialState[]> => {
  try {
    const r = await iAxios.get(API_URLs.settings.materials.getMaterialStates);
    console.log("getMaterialStates response:", r.data);
    return Array.isArray(r.data.member) ? r.data.member : [];
  } catch (e) {
    console.error("Error fetching material states:", e);
    return [];
  }
};

export const getMaterialEnergies = async (): Promise<MaterialEnergy[]> => {
  try {
    const r = await iAxios.get(API_URLs.settings.materials.getMaterialEnergies);
    console.log("getMaterialEnergies response:", r.data);
    return Array.isArray(r.data.member) ? r.data.member : [];
  } catch (e) {
    console.error("Error fetching material energies:", e);
    return [];
  }
};

export const postNewMaterial = async (data: any) => {
  try {
    const r = await iAxios.post(API_URLs.settings.materials.postMaterial, data);
    return r.data;
  } catch (e) {
    console.error("Error posting new material:", e);
    return null;
  }
};

export const getMaterialList = async (pageState: MaterialPageState) => {
  const obj: any = { ...pageState, order: null };
  Object.keys(pageState).forEach((key: any) => {
    if (key === "order") {
      obj["order[" + (pageState?.order?.dataKey ?? "") + "]"] =
        pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString();
    }
  });
  delete obj["order"];
  try {
    const r = await iAxios.get(
      API_URLs.settings.materials.getMaterialList +
        "?" +
        new URLSearchParams(obj)
    );
    return r?.data;
  } catch (e) {
    return null;
  }
};

export const getMaterialById = async (id: string) => {
  try {
    const r = await iAxios.get(
      API_URLs.settings.materials.getMaterialById?.replace("{id}", id)
    );
    return r.data;
  } catch (e) {
    return null;
  }
};

export const deleteMaterialById = async (id: string) => {
  try {
    const r = await iAxios.delete(
      API_URLs.settings.materials.deleteMaterialById?.replace("{id}", id)
    );
    return r.data;
  } catch (e) {
    return null;
  }
};

export const patchMaterialById = async (id: string, data: any) => {
  try {
    const r = await iAxios.patch(
      API_URLs.settings.materials.patchMaterialById?.replace("{id}", id),
      { ...data, id },
      {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      }
    );
    return r.data;
  } catch (e) {
    return null;
  }
};

export class MaterialService {
  static getMaterialTypes = async (params: any) => {
    const { id, ...otherParams } = params;
    try {
      return await Http.get(
        API_URLs.materials.getMaterialType?.replace("{id}", id),
        otherParams
      );
    } catch (error) {
      return error;
    }
  };

  /**
   * Machine
   * @param params
   * @returns
   */

  static getMaterialsStateForSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.getMaterialStateSelect, params);
    } catch (error) {
      return error;
    }
  };

  static getMaterialsEnergyForSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.getMaterialEnergySelect, params);
    } catch (error) {
      return error;
    }
  };

  static getMaterialsFromForSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.getMaterialFromSelect, params);
    } catch (error) {
      return error;
    }
  };

  static getMaterialsTypeForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.getMachineMaterialTypeSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getCraneMaterialsTypeForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.getCraneMaterialTypeSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getLiftingMaterialsTypeForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.getLiftingMaterialTypeSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  /**
   * Machine
   */

  static getMachineMaterial = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.machine.getMachine, params);
    } catch (error) {
      return error;
    }
  };

  static getAllMachineForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.machine.getMachineForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getOneMachineMaterial = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.materials.machine.getOneMachine}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static createMachineMaterial = async (data: any) => {
    try {
      return await Http.post(API_URLs.materials.machine.createMachine, data);
    } catch (error) {
      return error;
    }
  };

  static updateMachineMaterial = async (data?: any) => {
    try {
      return await Http.patch(API_URLs.materials.machine.updateMachine, data);
    } catch (error) {
      return error;
    }
  };

  static deleteMachineMaterial = async (id: number) => {
    try {
      return await Http.delete(
        `${API_URLs.materials.machine.deleteMachine}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  /**End Machine */

  /**
   * Grue or Crane
   */
  static getGrueMaterial = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.grue.getGrue, params);
    } catch (error) {
      return error;
    }
  };
  static getAllGrueForSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.grue.getGrueForSelect, params);
    } catch (error) {
      return error;
    }
  };

  static getOneGrueMaterial = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.materials.grue.getOneGrue}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static createGrueMaterial = async (data: any) => {
    try {
      return await Http.post(API_URLs.materials.grue.createGrue, data);
    } catch (error) {
      return error;
    }
  };

  static updateGrueMaterial = async (data?: any) => {
    try {
      return await Http.patch(API_URLs.materials.grue.updateGrue, data);
    } catch (error) {
      return error;
    }
  };

  static deleteGrueMaterial = async (id: number) => {
    try {
      return await Http.delete(`${API_URLs.materials.grue.deleteGrue}/${id}`);
    } catch (error) {
      return error;
    }
  };

  /** End GRue or Crane */

  /**
   * Levage or Lifting
   */
  static getLevageMaterial = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.levage.getLifting, params);
    } catch (error) {
      return error;
    }
  };

  static getAllLevageForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.levage.getLiftingForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getOneLevageMaterial = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.materials.levage.getOneLifting}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static createLevageMaterial = async (data: any) => {
    try {
      return await Http.post(API_URLs.materials.levage.createLifting, data);
    } catch (error) {
      return error;
    }
  };

  static updateLevageMaterial = async (data?: any) => {
    try {
      return await Http.patch(API_URLs.materials.levage.updateLifting, data);
    } catch (error) {
      return error;
    }
  };

  static deleteLevageMaterial = async (id: number) => {
    try {
      return await Http.delete(
        `${API_URLs.materials.levage.deleteLifting}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static getLevageMaterialHistoryList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.levage.levageHistory, params);
    } catch (error) {
      return error;
    }
  };

  static getOneLevageMaterialHistory = async (id?: any) => {
    try {
      return await Http.get(`${API_URLs.materials.levage.levageHistory}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static getOneLevageMaterialMovement = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.levage.levageMovement, params);
    } catch (error) {
      return error;
    }
  };
  static createLevageApprovisionment = async (data: any) => {
    try {
      return await Http.post(
        API_URLs.materials.levage.createApprovisionment,
        data
      );
    } catch (error) {
      return error;
    }
  };

  /** End Levage or lifting */

  /**
   * Barge or Chaland
   */
  static getChalandMaterial = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.chaland.getBarge, params);
    } catch (error) {
      return error;
    }
  };

  static getChalandForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.chaland.getBargeForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getOneChalandMaterial = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.materials.chaland.getOneBarge}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static createChalandMaterial = async (data: any) => {
    try {
      return await Http.post(API_URLs.materials.chaland.createBarge, data);
    } catch (error) {
      return error;
    }
  };

  static updateChalandMaterial = async (data?: any) => {
    try {
      return await Http.patch(API_URLs.materials.chaland.updateBarge, data);
    } catch (error) {
      return error;
    }
  };

  static deleteChalandMaterial = async (id: number) => {
    try {
      return await Http.delete(
        `${API_URLs.materials.chaland.deleteBarge}/${id}`
      );
    } catch (error) {
      return error;
    }
  };
  /** End Barge or chaland */

  /**
   * Remorquer or Tugboat
   */
  static getTugboatMaterial = async (params?: any) => {
    try {
      return await Http.get(API_URLs.materials.tugboad.getTugboad, params);
    } catch (error) {
      return error;
    }
  };

  static getTugboatForSelect = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.materials.tugboad.getTugboadForSelect,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static getOneTugboatMaterial = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.materials.tugboad.getOneTugboad}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static createTugboatMaterial = async (data: any) => {
    try {
      return await Http.post(API_URLs.materials.tugboad.createTugboad, data);
    } catch (error) {
      return error;
    }
  };

  static updateTugboatMaterial = async (data?: any) => {
    try {
      return await Http.patch(API_URLs.materials.tugboad.updateTugboad, data);
    } catch (error) {
      return error;
    }
  };

  static deleteTugboatMaterial = async (id: number) => {
    try {
      return await Http.delete(
        `${API_URLs.materials.tugboad.deleteTugboad}/${id}`
      );
    } catch (error) {
      return error;
    }
  };
  /** End Remorquer or Tugboat */
}
